const defaultState = {
    userContext: null,
    session: null
};

const reducer = (state = defaultState, action) => {
    switch(action.type) {
        case 'UPDATE_USER_CONTEXT':
            return {
                userContext: action.userContext,
                session: action.sessionToken
            };
        default:
            return state;
    }
};

export default {
    defaultState,
    reducer
}